<div class="fullscreen-wrapper">
  <div class="overlay"></div>

  <div class="container">
    <img src="assets/images/abc-logo.svg" alt="ABC Talkies Logo" class="logo" />

    <h1>Use the App for Best Experience</h1>
    <p>We do not recommend watching films in a mobile browser.</p>
    <p>For seamless viewing, download the ABC Talkies app.</p>

    <div class="store-buttons">
      @if (returnUrl == 'android') {
      <a href="https://play.google.com/store/apps/details?id=abctalkies.boxoffice.android" target="_blank">
        <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
          alt="Download on Google Play">
      </a>
      } @if (returnUrl == 'ios') {
      <a href="https://apps.apple.com/us/app/abc-talkies/id1586757822" target="_blank">
        <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
          alt="Download on App Store">
      </a>
      }
      @if (returnUrl != 'android' && returnUrl != 'ios') {
      <a href="https://play.google.com/store/apps/details?id=abctalkies.boxoffice.android" target="_blank">
        <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
          alt="Download on Google Play">
      </a>
      <a href="https://apps.apple.com/us/app/abc-talkies/id1586757822" target="_blank">
        <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
          alt="Download on App Store">
      </a>
      }
    </div>
    <button class="skip-btn" (click)="onclick()" type="button">Skip & Continue with Website</button>
  </div>
</div>